import * as _ from 'lodash';

import { InputData } from '../lab-test/input-data.model';
import { OnBoardingInput } from './onboarding-input.model';
import { InputDataAllowable } from '../lab-test/input-data-allowable.model';
import { SelectedTeaConfig } from '../common/selected-tea-config.model';
import { LevelData } from '../lab-test/level-data.model';
import { OnBoardingAnalyteExtensions } from './onboarding-analyte.model';

// ToDo: refactor this code to use a better way to check input values
export class InputDataHelper {

    static hasAnyPropertyValue(obj: Object): boolean {
        let hasValue = false;
        for (const property in obj) {
            if (obj[property] && typeof obj[property] === 'object') {
                hasValue = InputDataHelper.hasAnyPropertiesValue(obj[property]);
                if (hasValue) {
                    break;
                }
            } else {
                hasValue = InputDataHelper.isNullOrEmpty(obj[property]);
            }
        }
        return hasValue;
    }

    static isNullOrEmpty(obj: any): boolean {
        if (typeof obj === 'string' && obj.trim) {
            obj = obj.trim();
        }
        return obj === undefined || obj === null || obj === '';
    }

    static hasAllPropertiesValue(data: OnBoardingInput): boolean {
        if (data && InputDataHelper.checkInputData(data.input)
            && InputDataHelper.checkInputDataAllowable(data.allowableInput)) {
            return true;
        }
        return false;
    }

    static hasAnyChanges(data: OnBoardingInput, originalData: OnBoardingInput): boolean {
        if (!originalData) {    // instrument
            return InputDataHelper.hasAnyPropertyValue(data);
        }

        return OnBoardingAnalyteExtensions.isInputDataDirty(data, originalData);
    }

    static checkInputData(data: InputData): boolean {

        if (data
            && data.dateRange
            && data.groupType
            && data.harm
            && data.minimumPoints
            && data.mtbf
            && data.numberOfPatients
            && InputDataHelper.checkTeaData(data.selectedTeaConfig)
            && data.severityOfHarmId) {
            return true;
        }
        return false;
    }

    static checkInputDataAllowable(data: InputDataAllowable): boolean {
        if (data
            && data.qcFrequency
            && data.qcRuleId) {
            return true;
        }
        return false;
    }

    static hasAnyPropertiesValue<T>(obj: T, excludeProperty: string[] = []) {
        if (!obj) {
            return false;
        }
        const objectKeys = Object.keys(obj) as Array<keyof T>;
        let result = false;
        for (const key of objectKeys) {
            if (excludeProperty && excludeProperty.find(p => p === key)) {
                continue;
            }
            if (!this.isNullOrEmpty(obj[key])) {
                result = true;
            }
        }
        return result;
    }

    static checkTeaData(tea: SelectedTeaConfig): boolean {
        if (!tea) {
            return false;
        }

        if (tea.teaConfig && tea.teaConfig.teaConfigId) {
            return true;
        }

        if (tea.userDefinedAbsoluteValue || tea.userDefinedPercentageValue) {
            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/contracts/onboarding/input-data-helper.ts